import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalTimeline = ({ goals }) => {
  const sortedGoals = [...goals]?.sort((a, b) => 
    new Date(a.targetDate) - new Date(b.targetDate)
  );

  const getGoalIcon = (type) => {
    const icons = {
      car: 'Car',
      home: 'Home',
      education: 'GraduationCap',
      wedding: 'Heart',
      custom: 'Target'
    };
    return icons?.[type] || 'Target';
  };

  const getGoalColor = (type) => {
    const colors = {
      car: 'bg-blue-500',
      home: 'bg-emerald-500',
      education: 'bg-purple-500',
      wedding: 'bg-pink-500',
      custom: 'bg-amber-500'
    };
    return colors?.[type] || 'bg-gray-500';
  };

  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    })?.format(amount);
  };

  const calculateYearsFromNow = (targetDate) => {
    const target = new Date(targetDate);
    const today = new Date();
    const years = (target?.getFullYear() - today?.getFullYear()) + 
                  (target?.getMonth() - today?.getMonth()) / 12;
    return Math.max(0, years)?.toFixed(1);
  };

  if (goals?.length === 0) {
    return (
      <div className="bg-card rounded-xl border border-border p-8 text-center">
        <Icon name="Calendar" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
        <p className="text-muted-foreground">No goals to display on timeline</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Calendar" size={24} color="var(--color-primary)" />
        <h3 className="text-xl font-bold text-foreground">Goal Timeline</h3>
      </div>
      <div className="relative">
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />

        <div className="space-y-6">
          {sortedGoals?.map((goal, index) => (
            <div key={goal?.id} className="relative pl-16">
              <div className={`absolute left-0 ${getGoalColor(goal?.type)} p-3 rounded-full`}>
                <Icon name={getGoalIcon(goal?.type)} size={20} color="white" />
              </div>

              <div className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-foreground">{goal?.name}</h4>
                    <p className="text-sm text-muted-foreground capitalize">{goal?.type} Goal</p>
                  </div>
                  <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
                    {calculateYearsFromNow(goal?.targetDate)} years
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-3">
                  <div>
                    <p className="text-xs text-muted-foreground">Target Amount</p>
                    <p className="text-sm font-semibold text-foreground">{formatIndianCurrency(goal?.targetAmount)}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Target Date</p>
                    <p className="text-sm font-semibold text-foreground">
                      {new Date(goal.targetDate)?.toLocaleDateString('en-IN', { 
                        month: 'short', 
                        year: 'numeric' 
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GoalTimeline;